
const displayUtils = {
  getUserInitials(user) {
    if(!user) {
      console.error('ERROR: displayUtils.getUserInitials - user is undefined');
      return '';
    } else if(user.firstName && user.lastName) {
      return `${user.firstName.charAt(0).toUpperCase()}${user.lastName.charAt(0).toUpperCase()}`;
    } else if(user.username) {
      return user.username.charAt(0).toUpperCase();
    } else {
      return '?';
    }
  }
  /**
   * 
   * @param {object} user - user object
   * @returns {string} user's permissions separated by a comma to be displayed in the UI
   */
  , getUserPermissionString(user) {
      if(!user) return 'n/a';
      const { admin, authoring, support, accountManager } = user;
      let strings = [];
      if(admin) strings.push('Admin');
      if(authoring) strings.push('Authoring');
      if(support) strings.push('Support');
      if(accountManager) strings.push('Account Manager');
      if(!strings.length) strings.push('User');
      return strings.join(', ');
    }

  , getResourceIcon(url) {
    let icon = 'fas fa-lg fa-file-lines'; 
    if(url.indexOf('.pdf') > -1) {
      icon = 'fas fa-lg fa-file-pdf';
    } else if(url.indexOf('.xls') > -1) {
      icon = 'fas fa-lg fa-file-excel';
    } else if(url.indexOf('.doc') > -1) {
      icon = 'fas fa-lg fa-file-word';
    } else if(url.indexOf('.zip') > -1) {
      icon = 'fas fa-lg fa-file-zipper';
    } else if(url.indexOf('.mp4') > -1) {
      icon = 'fas fa-lg fa-file-video';
    } else if(url.indexOf('.png') > -1 || url.indexOf('.jpg') > -1) {
      icon = 'fas fa-lg fa-file-image'
    }
    return icon;
  }
}

export default displayUtils;


// WEBPACK FOOTER //
// global/utils/displayUtils.js